import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Pagination from "react-js-pagination";
import {
  AvatarPlaceholderSquare,
  Eye,
  Facebook,
  Globe,
  Instagram,
  JobPosition,
  Linkedin,
  LocationIcon,
  One,
  RightArrowShowProfile,
  ShareGrow,
  WhiteEye,
  XSocial,
  Youtube,
} from "../styled/AllImages";
import { useTranslation } from "react-i18next";
import PaginatedList from "./PaginationComponent";
import { useUser } from "../../context/userContext";
import { NoRecord } from "../common/noRecord/NoRecord";
import { Box, ButtonStyled } from "../styled/Elements";
import { formatNumber } from "../../utils";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import {
  buildProfilePath,
  isValidProfileUsername,
} from "../../utils/profileUsername";

const ProfilesList = ({ selectedCity }) => {
  const {
    searchProfileData,
    setCurrentPage,
    currentPage,
    perPage,
    totalPages,
    queryData,
  } = useUser();

  const { i18n, t } = useTranslation();

  return (
    <PageWrapper lang={i18n.language}>
      <CardGrid lang={i18n.language}>
        {!searchProfileData || searchProfileData?.length === 0 ? (
          <NoRecord />
        ) : (
          searchProfileData?.map((user) => (
            <Card key={user?.id}>
              {/* <ViewBox>
                <WhiteEye width="14px" height="14px" />
                <span>{formatNumber(user?.profile_views_count) ?? 0}</span>
              </ViewBox> */}
              <AvatarWrapper>
                <Avatar
                  src={
                    user.profile
                      ? resolveMediaUrl(user.profile)
                      : AvatarPlaceholderSquare
                  }
                  alt={user?.name}
                />
              </AvatarWrapper>
              <CardContent>
                <Box className="d-flex justify-content-between w-100">
                  <Name>{user?.name}</Name>
                  <ViewBox>
                    <WhiteEye width="14px" height="14px" />
                    <span>{formatNumber(user?.profile_views_count) ?? 0}</span>
                  </ViewBox>
                </Box>

                <Box className="loc-pos-wrapper">
                  <Location className="text-nowrap">
                    <LocationIcon
                      style={{ marginBottom: "5px", marginRight: "5px" }}
                      width="20px"
                    />
                    {/* {i18n.language === "en"
                    ? user?.personal_information?.city?.name_en
                    : user?.personal_information?.city?.name_ar} */}
                    {user?.city}
                  </Location>

                  <Position className="text-nowrap">
                    <JobPosition
                      style={{ marginBottom: "6px", marginRight: "5px" }}
                      width="20px"
                    />
                    {user?.fal_information?.specialization?.id == 3
                      ? t("broker_and_marketer")
                      : user?.fal_information?.specialization?.id == 1
                      ? t("marketer")
                      : t("broker")}
                  </Position>
                </Box>

                <Stats>
                  <Box className="d-flex justify-content-between">
                    <span>{t("real_estate_listings")}</span>
                    <span>{Number(user?.listing_count)}</span>
                  </Box>
                  <Separator />
                  <Box className="d-flex justify-content-between">
                    <span>{t("properties")}</span>
                    <span>{Number(user?.looking_for_count)}</span>
                  </Box>
                </Stats>

                {/* <SocialIcons>
                  {user?.social_media?.website_url && (
                    <a
                      href={user.social_media.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <Globe style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  )}
                  {
                    <a
                      href={user.social_media.one_day_profile_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <One style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  }
                  {user?.social_media?.facebook_profile_link && (
                    <a
                      href={user.social_media.facebook_profile_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <Facebook style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  )}
                  {user?.social_media?.instagram_profile_link && (
                    <a
                      href={user.social_media.instagram_profile_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <Instagram style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  )}
                  {user?.social_media?.x_profile_link && (
                    <a
                      href={user.social_media.x_profile_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <XSocial style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  )}
                  {user?.social_media?.linkedin_profile_link && (
                    <a
                      href={user.social_media.linkedin_profile_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <Linkedin style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  )}
                  {user?.social_media?.youtube_channel_link && (
                    <a
                      href={user.social_media.youtube_channel_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconWrapper>
                        <Youtube style={{ width: "15px" }} />
                      </IconWrapper>
                    </a>
                  )}
                </SocialIcons> */}
              </CardContent>

              {/* <Separator /> */}

              {/* <ButtonStyled label={t("view_profile")} bg="var(--themeColorSecondary)" /> */}
              {isValidProfileUsername(user?.username) && (
                <Box className="px-2 w-100 mt-3">
                  <ViewProfile
                    target="_blank"
                    href={buildProfilePath(user?.username)}
                    lang={i18n.language}
                  >
                    {t("view_profile")}{" "}
                  </ViewProfile>
                </Box>
              )}
            </Card>
          ))
        )}
      </CardGrid>

      {searchProfileData && searchProfileData?.length > 0 && (
        <div className="d-flex align-items-center justify-content-center text-nowrap">
          {/* <p className="pages-found">Showing {perPage} of {searchProfileData?.length}</p> */}
          <PaginatedList />
        </div>
      )}
    </PageWrapper>
  );
};

export default ProfilesList;

// Styled Components
const PageWrapper = styled.div`
  padding: 40px 90px;
  min-height: 100%;
  .pages-found {
    font-size: 12px;
    margin-top: 30px;
  }

  @media (max-width: 1024px) {
    padding: 40px 15px;
  }
  @media (max-width: 768px) {
    padding: 40px 10px;
  }

  .title {
    padding: 0 0 20px 40px;
    font-size: 24px;

    @media (max-width: 768px) {
      padding: 0 0 16px 20px;
      font-size: 20px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
      padding-left: 14px;
    }

    font-family: ${({ lang }) =>
      lang === "en" ? "var(--heavy)" : "var(--arExtraBold)"};
    color: var(--darkGrey);
  }

  @media (max-width: 384px) {
    padding: 40px 10px;
  }
`;

const Stats = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1px 15px;
  width: 100%;
  color: var(--lightGrey);
  margin-top: 18px;

  @media (max-width: 400px) {
    font-size: 12px;
  }
  @media (max-width: 330px) {
    font-size: 11px;
  }
`;

const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
  justify-content: baseline;
  /* justify-content: ${({ lang }) =>
    lang === "en" ? "flex-start" : "flex-end"}; */
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  /* & > div:last-child {
    margin-right: auto;
    margin-left: 15px;
  } */

  //@media (max-width: 600px) {
  //justify-content: center;
  //}
`;

const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  border: 1.5px solid #e4e8eb;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  min-height: 360px;
  position: relative;
  /* padding: 10px 10px 0px 10px;  */

  flex: 1 1 calc(25% - 20px);
  max-width: calc(25% - 20px);

  @media (max-width: 992px) {
    flex: 1 1 calc(33.33% - 20px);
    max-width: calc(33.33% - 20px);
  }

  @media (max-width: 650px) {
    flex: 1 1 calc(50% - 20px);
    /* max-width: calc(50% - 20px); */
    max-width: 50%;
  }

  @media (max-width: 440px) {
    /* max-width: calc(50% - 20px); */
    max-width: 50%;
  }
`;

const AvatarWrapper = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 12px;
  margin-bottom: 16px;
  padding: 10px 10px 0 10px;
  object-fit: cover;
  /* padding: 14px; */
  overflow: hidden;

  @media (max-width: 768px) {
    height: 180px;
    /* padding: 10px; */
  }

  @media (max-width: 480px) {
    height: 180px;
    /* padding: 8px; */
  }
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  display: block;
`;

const Name = styled.h3`
  /* margin: 0; */
  font-size: 1.1rem;
  font-weight: 600;
  display: block;
  text-align: start !important;
  width: 100%;
  padding-left: 15px;
  padding-right: 5px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
  }

  color: var(--text);
`;

const Location = styled.p`
  /* margin: 4px 0; */
  font-size: 14px;
  @media (max-width: 339px) {
    align-items: start;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }

  color: var(--lightGrey);
`;

const Position = styled.p`
  /* margin: 2px 0 12px; */
  font-size: 13.5px;
  text-align: start;

  @media (max-width: 768px) {
    font-size: 12.5px;
  }
  @media (max-width: 339px) {
    align-items: start;
  }

  @media (max-width: 480px) {
    font-size: 11.5px;
  }

  color: var(--lightGrey);
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  padding: 5px 3px;
  min-height: 36px;
`;

const IconWrapper = styled.a`
  width: 30px;
  height: 30px;
  text-decoration: none;
  svg:first-of-type {
    [stroke] {
      stroke: ${({ iconColor }) =>
        iconColor ? iconColor : "var(--themeColorSecondary)"};
    }
    [fill] {
      fill: ${({ iconColor }) =>
        iconColor ? iconColor : "var(--themeColorSecondary)"};
    }
  }

  @media (max-width: 768px) {
    width: 26px;
    height: 26px;
  }

  @media (max-width: 480px) {
    width: 22px;
    height: 22px;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #e4e8eb;
`;

const Separator = styled.hr`
  width: 100%;
  border: none;
  height: 1.5px;
  background-color: #b8b7b7;
  margin: 12px 0;
`;

const ViewProfile = styled.a`
  background-color: var(--themeColorSecondary);
  font-size: 16px;
  margin-bottom: 1rem;
  width: 100%;
  border-radius: 8px;

  font-family: ${({ lang }) =>
    lang === "en" ? "var(--semiBold)" : "var(--arSemiBold)"};
  color: var(--darkGrey);
  display: flex;
  justify-content: center;
  color: var(--white);
  align-items: center;
  padding: 10px 0 10px 0;
  gap: 6px;
  cursor: pointer;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;

  .page-link {
    background: var(--bgGradient);
    color: #fff;
  }

  .page-item.active .page-link {
    background: var(--purple) !important;
    border-color: var(--primary) !important;
    margin: 0 1px;
  }

  .page-item {
    border-radius: 5px !important;
    overflow: hidden;
  }

  .page-item:last-child .page-link,
  .page-item:first-child .page-link {
    border-radius: 5px !important;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  width: 100%;
`;

const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .loc-pos-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;

    @media (max-width: 509px) {
      flex-direction: column;
      align-items: start;
    }
  }
`;

const ViewBox = styled.div`
  /* position: absolute; */
  /* top: 21px; */
  /* right: 21px; */
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  /* z-index: 2; */
  height: 22px;
  margin-bottom: 12px;
  margin-right: 15px;
  margin-left: 15px;
`;
